module.exports = "<div class=\"about-pane\">\n  <div class=\"modal-header\">\n    <h1 class=\"overlay-title\">API Design First Workflow</h1>\n    <h3>Easily create API specifications</h3>\n  </div>\n   <div class=\"file-arrow\"></div>\n  <div class=\"sample\">Try a sample here</div>\n  <button id=\"dismis-intro\" class=\"btn btn-warning btn-close\" ng-click=\"toggleAboutEditor(false)\">\n  </button>\n  <div class=\"yaml-author\">Write API specs in YAML...</div>\n  <div class=\"sw-preview\">...Preview documentation in Swagger</div>\n  <button class=\"btn btn-warning btn-intro\" ng-click=\"toggleAboutEditor(false)\">Got it!</button>\n</div>\n\n\n";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/intro.html
 ** module id = 544
 ** module chunks = 0
 **/